export default class ChannelsEditController {
    constructor($scope, $routeParams, $location, channelsService, authenticationService, $mdDialog, notificationsService, globalConstants) {
        this.$location = $location;
        this.$scope = $scope;
        this.channelsService = channelsService;
        this.authenticationService = authenticationService;
        this.notificationsService = notificationsService;
        this.$routeParams = $routeParams;
        this.$mdDialog = $mdDialog;
        this.allowEdit = true;
        this.globalConstants = globalConstants;

        this.channelsService.getById($routeParams.id).then(resp => {
            this.channel = resp.data;
            this.channel.Id = $routeParams.id;
            if(resp.data.isGlobal && !this.authenticationService.isSuperUser())
            {
                this.allowEdit = false;
            } 
        }, error => {
            $location.path("/");
        });

        this.avatar = {
            icon: 'default1.png',
            image: undefined
        };        
    }

    addNewAvatar(){
        this.showAddForm = true;
    }

    removeAvatar(avatar){
        var index = this.channel.avatars.indexOf(avatar);
        this.channel.avatars.splice(index, 1);           
    }

    addAvatar() {
        if(this.avatar === undefined || this.avatar.name == "" || this.avatar.name == null) {
            this.notificationsService.show("Please enter an avatar name", "error");
            return;
        }
        //copy list
        var avatar = JSON.parse(JSON.stringify(this.avatar));
        var that = this;
        that.btnDisabled = true;
        
        this.readFile().then(function (data){
            if(data.image == "" || data.image == null) {
                
                //avatar.image = that.avatar.icon;
                avatar.icon = that.avatar.icon;
                avatar.imagetype = "image/png";
            }
            else{
                avatar.icon = undefined;
                avatar.image = data.image;
                avatar.imagetype = data.mimetype;
            }
            that.$scope.ctrl.channel.avatars.push(avatar);
            that.avatar = undefined;
            document.getElementById('file').value = "";
            that.$scope.ctrl.btnDisabled = false;
            that.$scope.ctrl.showAddForm = false;
            that.$scope.$apply();
        })
    }

    readFile() {
        return new Promise(function(resolve, reject) {
            var f = document.getElementById('file').files[0],
            r = new FileReader(),
            data = [];

            if(!f){
                resolve(data);
            }
        
            var mimetype = f.type;

            r.onloadend = function(e) {
                var image = btoa(new Uint8Array(e.target.result).reduce(function (data, byte){
                    return data + String.fromCharCode(byte);
                }, ''));

                data.image = image;
                data.mimetype = mimetype;
                data.fileextension = f.name.split('.').pop();
                
                resolve(data);
            }
            r.readAsArrayBuffer(f);
        });
    };

    onSave() { 
        var that = this;
        this.channelsService.update(this.channel).then(resp => {
            // that.$location.path(that.authenticationService.isSuperUser() ?
            //     "/subscriptions" : 
            //     "/manage")
            that.notificationsService.show("Channel updated", "success");
        }, resp =>{
            that.notificationsService.show("Error updating channel", "error");
        });
    } 

    goBack(){
        this.$location.path(this.authenticationService.isSuperUser() ?
                "/subscriptions" : 
                "/manage")
    }

    delete(){
        var that = this;
        this.channelsService.delete(this.$routeParams.id).then(resp => {
            that.$location.path(that.authenticationService.isSuperUser() ?
                "/subscriptions" : 
                "/manage")
        });
    }

    deleteChannel(){
        this.channelsService.deleteChannel(this.$routeParams.id).then(resp => {
            this.$location.path(this.authenticationService.isSuperUser() ?
                "/subscriptions/" : 
                "/manage");
        });
    }

    showWarning(ev) {
        this.$mdDialog.show({
            contentElement: '#deleteChannelDialog',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose: true
        });
    };

    hideWarning(ev) {
        this.$mdDialog.hide({
            contentElement: '#deleteChannelDialog',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose: true
        });
    };
}


// WEBPACK FOOTER //
// ./src/js/components/channels/channels.edit.controller.js